window.dataLayer = window.dataLayer || [];
function gtag() {
	dataLayer.push(arguments);
}
gtag("consent", "default", {
	ad_storage: "denied",
	analytics_storage: "denied",
	ad_user_data: "denied",
	ad_personalization: "denied"
});
